import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import NavaService from "../services/NavaService";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from || "/admin";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError("Enter your username and password.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await NavaService.login(username.trim(), password);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.message || "Login failed. Check your details and try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper className="flexCenter">
      <BackHomeBtn onClick={() => navigate("/")} className="pointer" type="button">
        ← Back to home
      </BackHomeBtn>

      <Card>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <img src="/sare-logo.png" alt="Sare Auctioneers logo" style={{ width: 70, height: 44, objectFit: "contain", margin: "0 auto 8px" }} />
          <h1 style={{ fontSize: "18px", fontWeight: 800, margin: 0, color: "#5d191a" }}>SARE AUCTIONEERS</h1>
          <p className="font13" style={{ color: "#707070", margin: "6px 0 0" }}>Admin sign in</p>
        </div>

        <Form onSubmit={handleSubmit}>
          <label className="font13">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />

          <label className="font13">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {error && <ErrorText>{error}</ErrorText>}

          <SubmitBtn type="submit" disabled={loading} className="pointer animate radius8">
            {loading ? "Signing in..." : "Sign in"}
          </SubmitBtn>
        </Form>
      </Card>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #f5f7fb;
  position: relative;
`;

const BackHomeBtn = styled.button`
  position: absolute;
  top: 24px;
  left: 24px;
  border: 0;
  background: transparent;
  color: #5d191a;
  font-weight: 700;
  font-size: 14px;

  &:hover {
    color: #5d191a;
  }

  @media (max-width: 480px) {
    top: 16px;
    left: 16px;
    font-size: 13px;
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(19, 54, 92, 0.1);
  padding: 36px 32px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;

  label {
    margin-top: 16px;
    margin-bottom: 6px;
    color: #13365c;
    font-weight: 700;
  }

  input {
    height: 42px;
    border-radius: 8px;
    border: 1px solid #d8dee8;
    padding: 0 14px;
    outline: none;
    font-size: 14px;

    &:focus {
      border-color: #5d191a;
      box-shadow: 0 0 0 3px rgba(93, 25, 26, 0.15);
    }
  }
`;

const ErrorText = styled.p`
  color: #d63b3b;
  font-size: 13px;
  margin: 14px 0 0;
`;

const SubmitBtn = styled.button`
  margin-top: 26px;
  height: 44px;
  border: 0;
  background: #5d191a;
  color: #fff;
  font-weight: 700;
  font-size: 15px;

  &:hover {
    background: #421214;
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;